
































import Vue from 'vue';
import Component from 'vue-class-component';
import Layout from '@/modules/shared/layouts/components/Layout.vue';
import { user } from '@/modules/shared/shared/store/namespaces';
import { FETCH_USER } from '@/modules/users/store/user.actions';
import {
    HAS_PRIVILEGES_OVER_CONTACTS,
    HAS_PRIVILEGES_OVER_CUSTOMERS,
    HAS_PRIVILEGES_OVER_DIRECTORY_GROUPS,
    HAS_PRIVILEGES_OVER_EQUIPMENTS,
    HAS_PRIVILEGES_OVER_FEEDBACKS,
    HAS_PRIVILEGES_OVER_FINANCES,
    HAS_PRIVILEGES_OVER_HEALTH_REPORTS,
    HAS_PRIVILEGES_OVER_PDT,
    HAS_PRIVILEGES_OVER_REPORTS,
    HAS_PRIVILEGES_OVER_TICKETS,
    IS_EMPLOYEE,
    UserGetters,
} from '@/modules/users/store/user.getters';
import DaycoLoader from '@/modules/shared/shared/components/Loader.vue';
import { EventBus } from '@/main';
import { EventBusMessages } from '@/modules/shared/shared/domain/constants/event-bus-messages';
import FeedbackIcon from '@/modules/feedbacks/components/FeedbackIcon.vue';
import CreateFeedbackModal from '@/modules/feedbacks/components/FeedbackModal.vue';
import PortalMessage from '@/modules/shared/shared/components/PortalMessage.vue';
import { defineAbilitiesFor } from '@/plugins/acl/acl-functions';
import { UserRole } from '@/modules/users/domain/user-role';

@Component({
    components: {
        PortalMessage,
        CreateFeedbackModal,
        DaycoLoader,
        Layout,
        FeedbackIcon,
    },
    computed: {},
})
export default class Portal extends Vue {
    showLoader: boolean = false;

    redirect() {
        // if (this.$router.currentRoute.name !== 'dashboard') {
        //    console.log('we are not in dashboad... where are we?', this.$router.currentRoute.name);
        //    this.$router.push(this.$router.currentRoute.name as RawLocation);
        //} else if (this.IS_EMPLOYEE) {
        if (this.IS_EMPLOYEE) {
            if (this.HAS_PRIVILEGES_OVER_FEEDBACKS) {
                this.$router.push({ name: 'feedbacks' });
            } else if (this.HAS_PRIVILEGES_OVER_HEALTH_REPORTS) {
                this.$router.push({ name: 'dayco-reports' });
            } else if (this.HAS_PRIVILEGES_OVER_TICKETS) {
                this.$router.push({ name: 'dayco-tickets' });
            } else if (this.HAS_PRIVILEGES_OVER_PDT) {
                this.$router.push({ name: 'access-permissions' });
            } else if (this.HAS_PRIVILEGES_OVER_CONTACTS) {
                this.$router.push({ name: 'contacts' });
            } else if (this.HAS_PRIVILEGES_OVER_CUSTOMERS) {
                this.$router.push({ name: 'dayco-customers' });
            } else if (this.HAS_PRIVILEGES_OVER_FINANCES) {
                this.$router.push({ name: 'dayco-finances' });
            } else if (this.HAS_PRIVILEGES_OVER_EQUIPMENTS) {
                this.$router.push({ name: 'dayco-equipments' });
            }
        } else {
            // this.$router.push({ name: 'tickets' });
            // if (this.HAS_PRIVILEGES_OVER_TICKETS) {
            //     this.$router.push({ name: 'tickets' });
            // } else if (this.HAS_PRIVILEGES_OVER_PDT) {
            //     this.$router.push({ name: 'access-permissions' });
            // } else if (this.HAS_PRIVILEGES_OVER_REPORTS) {
            //     this.$router.push({ name: 'reports' });
            // } else if (this.HAS_PRIVILEGES_OVER_FINANCES) {
            //     this.$router.push({ name: 'finances' });
            // } else if (this.HAS_PRIVILEGES_OVER_CONTACTS) {
            //     this.$router.push({ name: 'contacts' });
            // }
        }
    }

    mounted() {
        const preloader = document.getElementById('app-preloader');
        if (preloader) preloader.style.display = 'none';
        this.FETCH_USER();
        this.$ability.update(defineAbilitiesFor(this.userRole));
        this.$nextTick(() => {
            EventBus.$emit(EventBusMessages.HIDE_LOADER);
        });

        EventBus.$on(EventBusMessages.SHOW_LOADER, () => {
            this.showLoader = true;
        });

        EventBus.$on(EventBusMessages.HIDE_LOADER, () => {
            this.showLoader = false;
        });
    }

    @user.Getter(HAS_PRIVILEGES_OVER_TICKETS) HAS_PRIVILEGES_OVER_TICKETS;
    @user.Getter(HAS_PRIVILEGES_OVER_CONTACTS) HAS_PRIVILEGES_OVER_CONTACTS;
    @user.Getter(HAS_PRIVILEGES_OVER_CUSTOMERS) HAS_PRIVILEGES_OVER_CUSTOMERS;
    @user.Getter(UserGetters.GET_USER_ROLE)
    userRole!: UserRole;
    @user.Getter(HAS_PRIVILEGES_OVER_DIRECTORY_GROUPS)
    HAS_PRIVILEGES_OVER_DIRECTORY_GROUPS;
    @user.Getter(HAS_PRIVILEGES_OVER_EQUIPMENTS) HAS_PRIVILEGES_OVER_EQUIPMENTS;
    @user.Getter(HAS_PRIVILEGES_OVER_FEEDBACKS) HAS_PRIVILEGES_OVER_FEEDBACKS;
    @user.Getter(HAS_PRIVILEGES_OVER_FINANCES) HAS_PRIVILEGES_OVER_FINANCES;
    @user.Getter(HAS_PRIVILEGES_OVER_HEALTH_REPORTS)
    HAS_PRIVILEGES_OVER_HEALTH_REPORTS;
    @user.Getter(HAS_PRIVILEGES_OVER_PDT) HAS_PRIVILEGES_OVER_PDT;
    @user.Getter(HAS_PRIVILEGES_OVER_REPORTS) HAS_PRIVILEGES_OVER_REPORTS;
    @user.Getter(IS_EMPLOYEE) IS_EMPLOYEE;
    @user.Action(FETCH_USER) FETCH_USER;
}
